// extracted by mini-css-extract-plugin
module.exports = {"container":"AlsoAvailableOnSectionFooter_container__j651v"};